import { render, staticRenderFns } from "./ProjectNestedPage.vue?vue&type=template&id=829ce91a"
import script from "./ProjectNestedPage.vue?vue&type=script&lang=js"
export * from "./ProjectNestedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports